<template>
  <div>
    <slot></slot>
    <Teleport to="#modals">
      <WdsModal
        :show="show"
        :title="confirmMessage"
        data-test="delete-contact-modal"
        @cancel="$emit('cancel')"
      >
        <WdsAlert v-if="errorBannerMessage" error class="tw-mb-5">
          {{ errorBannerMessage }}
        </WdsAlert>
        <WdsStack direction-column>
          <div>
            <slot name="body" />
          </div>
          <div>
            <WdsStack justify-space-between gap-md>
              <WdsButton tertiary @click="$emit('cancel')">
                {{ cancelButtonText }}
              </WdsButton>
              <ButtonWithSpinner
                color="danger"
                size="sm"
                :status="buttonStatus"
                :text-while-working="deleteButtonTextWhileWorking"
                data-test="confirm-deletion"
                @click="handleOnConfirm"
              >
                {{ confirmButtonText }}
              </ButtonWithSpinner>
            </WdsStack>
          </div>
        </WdsStack>
      </WdsModal>
    </Teleport>
  </div>
</template>

<script>
import { WdsButton, WdsModal, WdsStack, WdsAlert } from '@worksome/wds-components'
import ButtonWithSpinner from '@/components/ButtonWithSpinner.vue'

export default {
  components: { ButtonWithSpinner, WdsButton, WdsModal, WdsStack, WdsAlert },
  props: {
    confirmMessage: {
      type: String,
      default: $t('Are you sure you want to delete this contact?'),
    },
    confirmButtonText: {
      type: String,
      default: $t('Yes, delete contact'),
    },
    cancelButtonText: {
      type: String,
      default: $t('Cancel'),
    },
    deleteButtonTextWhileWorking: {
      type: String,
      default: $t('Deleting'),
    },
    onConfirm: {
      type: Function,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
    errorBannerMessage: {
      type: String,
      default: '',
    },
  },
  emits: ['cancel'],
  data() {
    return {
      buttonStatus: 'enabled',
    }
  },
  methods: {
    async handleOnConfirm() {
      this.buttonStatus = 'working'

      await this.onConfirm()

      this.buttonStatus = 'enabled'
    },
  },
}
</script>
